<template>
  <div class="swiper-navigation-btns">
    <button :class="['carousel__btn', 'carousel__btn--prev', 'slick-arrow', animating == -1 ? 'slick-arrow--animated' : '']" @click="slideTo(-1)">
      <span :class="['slider__spinner', 'slider__spinner--black', animating == -1 ? 'animate-arrow' : '']">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="39" width="39" viewBox="0 0 55 55">
          <circle cx="27.5" cy="27.5" r="26.5" stroke-width="2" />
        </svg>
      </span>
    </button>
    <div class="slider-info">
      <div class="slider-current">
        <div :class="['slider-next-item', animating != 0 ? 'shift-top' : '']">{{ nextIndex + 1 | strPadding('l', 2, '0') }}</div>
        <div :class="['slider-current-item', animating != 0 ? 'shift-bottom' : '']">{{ currIndex + 1 | strPadding('l', 2, '0') }}</div>
      </div>
      <div class="slider-num-spliter">/</div>
      <div class="slider-total">{{total | strPadding('l', 2, '0') }}</div>
    </div>
    <button :class="['carousel__btn', 'carousel__btn--next', 'slick-arrow', animating == 1 ? 'slick-arrow--animated' : '']" @click="slideTo(+1)">
      <span :class="['slider__spinner', 'slider__spinner--black', animating == 1 ? 'animate-arrow' : '']">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="39" width="39" viewBox="0 0 55 55">
          <circle cx="27.5" cy="27.5" r="26.5" stroke-width="2" />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import utils from '@/utils/index';

export default {
  name: "SwiperNavigator",
  props: {
    xSwiper: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      animating: 0,
      currIndex: 0,
      nextIndex: 0,
    }
  },
  created() {},
  mounted() {
    if (this?.xSwiper?.realIndex) {
      this.currIndex = this.xSwiper.realIndex;
    }
  },
  computed:{
    swiper(){
      return this.xSwiper
    }
  },
  methods: {
    // 切换Swiper
    slideTo(direction) {
      if (this.xSwiper?.animating) return false;
      let isLoop = this.xSwiper?.params?.loop;
      let newNext = -1
      if (direction === 1) {
        newNext = this.xSwiper.realIndex + 1;
        if (newNext <= this.total - 1) {
          // 
        } else if (isLoop && newNext > this.total - 1) {
          newNext =  0;
        } else {
          return;
        }
        this.nextIndex = newNext;
        this.xSwiper.slideNext();
      } else {
        newNext = this.xSwiper.realIndex - 1;
        if (newNext >= 0) {
          // 
        } else if (isLoop && newNext < 0) {
          newNext = this.total - 1;
        } else {
          return;
        }
        this.nextIndex = newNext;
        this.xSwiper.slidePrev();
      }
      // 
      this.animating = direction;
      this.resetAnimationStatus(1000, () => {
        this.currIndex = newNext;
      });
    },
    // 重置动画标识状态
    resetAnimationStatus(time, callback) {
      setTimeout(() => {
        this.animating = 0;
        utils.isFunction(callback) && callback();
      }, time || 0);
    }
  },
  filters: {
    strPadding(str, direction, maxLength, fillString) {
      return utils.strPadding(str, direction, maxLength, fillString);
    }
  }
};
</script>

<style lang="scss" scoped>
  @keyframes colorTop {
    0% { border-left-color: #000; }
    25% { border-top-color: #000; }
    50% { border-right-color: #000; }
  }
  .slick-arrow {
    background-color: #fff; transition: background-color .2s linear;
    cursor: pointer;
    &::after {
      content: "";
      background: url(../assets/imgs/icons/arrow-big.svg) no-repeat 50%;
      display: block; width: .875rem; height: .875rem;
    }
  }
  .slider__spinner {
    position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); display: flex; font-size: 0;
    circle { fill: none; stroke: #fff; stroke-linecap: square; }
    &.animate-arrow svg { animation: rotate-forward 1s ease-out; }
    &.animate-arrow circle { animation: animate-arrow 1s cubic-bezier(0.8, 0, 0.9, 1); }
  }
  .slider__spinner--black circle { stroke: #000; }
  .swiper-navigation-btns {
    display: flex; justify-content: center; align-items: center; padding: 28px 0;
    .slick-arrow {
      position: relative; width: 2.375rem; height: 2.375rem; padding: 0;
      border: .0625rem solid #dfdfdf; border-radius: 50%; transition: none;
      &::after {
        position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
        background: url(../assets/imgs/icons/arrow-bigger.svg) no-repeat 50%;
      }
    }
    .carousel__btn {
      .slider__spinner {
        overflow: hidden;
        svg {
          transform: rotate(-90deg);
          circle { stroke-dasharray: 1 226.19467px; stroke-dashoffset: -226.19467px; }
        }
      }
    }
    .carousel__btn--prev {
      &::after { transform: translate(-50%,-50%) rotate(90deg); }
    }
    .carousel__btn--next {
      &::after { transform: translate(-50%,-50%) rotate(-90deg); }
    }
    .slider-info {
      display: flex; justify-content: center; align-items: center; margin: 0 15px;
      color: #000; font-size: .8125rem; line-height: 1.5625rem;
      .slider-current {
        position: relative; overflow: hidden; width: 1.125rem; height: 1.5625rem; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; font-size: .8125rem; text-align: right;
        .slider-next-item { position: absolute; top: -100%; right: 0; }
        .slider-current-item { position: absolute; top: 0; right: 0; }
        .shift-top { animation: shift-top 1s linear; }
        .shift-bottom { animation: shift-bottom 1s linear; }
      }
      .slider-num-spliter { margin: 0 4px; }
      .slider-total { font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; text-align: left; width: 1.125rem; }
    }
  }
  @media screen and (min-width: 64em) {
    .slick-arrow--animated:before { transform: rotate(225deg); animation: colorTop 1s; }
    .slick-arrow:hover {
      background-color: #000; border-color: #000;
      &::after {
        background: url(../assets/imgs/icons/arrow-bigger-white.svg) no-repeat 50%;
      }
      &.slick-arrow--animated {
        background-color: #fff; border-color: #dfdfdf;
        &::after {
          background: url(../assets/imgs/icons/arrow-bigger.svg) no-repeat 50%;
        }
      }
    }
  }
</style>